import request from "./request";

const api = {
  getCountryList: "country/getCountryList",
};
export default {
  getCountryList(parameter) {
    return request({
      url: api.getCountryList,
      method: "POST",
      data: parameter,
    });
  },
};
